import Box from '@mui/material/Box';
import { ASSETS_PATH } from '../../services/endpoints';
import useMediaQuery from '@mui/material/useMediaQuery';
import { logotypeStyles } from './logotypeStyles';
import { Theme } from '@mui/material/styles';

export interface ILogotypeProps {
  theme: Theme;
}

export const Logotype = ({ theme }: ILogotypeProps) => {
  const isDark = theme.palette.mode === 'dark';
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = logotypeStyles;
  const logoImagePath = `${ASSETS_PATH}/img/brickken_header.png`;
  const logoImagePathBlack = `${ASSETS_PATH}/img/brickken_header_black.png`;
  const logoImageLittle = `${ASSETS_PATH}/img/brickken_logo_little.png`;

  const getLogotype = () => {
    if (isDark && isDownSm) {
      return (
        <Box
          component='img'
          alt='Brickken logotype'
          src={logoImageLittle}
          sx={classes.logoLittle}
        />
      );
    }
    if (isDark) {
      return (
        <Box
          component='img'
          alt='Brickken logotype'
          src={logoImagePath}
          sx={classes.logo}
        />
      );
    }
    if (isDownSm) {
      return (
        <Box
          component='img'
          alt='Brickken logotype'
          src={logoImageLittle}
          sx={classes.logoLittle}
        />
      );
    }
    return (
      <Box
        component='img'
        alt='Brickken logotype'
        src={logoImagePathBlack}
        sx={classes.logo}
      />
    );
  };

  return <> {getLogotype()}</>;
};
